import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import SearchLocationDialog from './SearchLocationDialog'
import { useDispatch } from 'react-redux'
import { useAlert } from 'react-alert'
import * as regex from '../../../Common/Regex'
const MediaWrap = styled.div`
  width:1800px;
  display: flex; /* 横並び */
  flex-wrap: wrap;
  margin: 4px;
  box-shadow: 0 0 3px 2px ${props => props.selected ? 'rgba(0,128,0,0.8)' : 'rgba(0,0,0,0.4)'};

  color: #000;
  font-size: 16px;

  text-align: center;
  align-items: center;
`

const MediaItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  height: 40px;
  border-right: 2px dashed #fff;
`
const MediaRow = styled.div`
  display: flex; /* 縦並び */
  flex-direction: row;
  height: 40px;
`
const TextWrap = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 
const InputField = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 80px;
`;

const MediaDataLocation= (props) => {
  const {
    data,onReSerach,handleChange,isEdit,dataIndex,dataLength,locationStoreList
  } = props
  //const [isEdit,setIsEdit]= useState(false);
  const dispatch = useDispatch();
  const alert = useAlert();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogData, setDaialogData] = useState(data);
  const [editData, setEditData] = useState({});

  const handleInputChange = (e,index) => {
    const { id, value } = e.target;
    data.patternLocationInfo[index].editLocationNum = value   
    var l = locationStoreList.find((l)=>l.locationNum == value)
    if(!l){
      l = {
       shippingCd:'',
       shippingName:''
      }
    }
    console.log(id)
    setEditData((prev) => ({ ...prev, [id]: value,[`shippingCd${index}`]: l.shippingCd,[`shippingName${index}`]: l.shippingName  }));
  };  
  // 初期値
  useEffect(() => {
    var tmpEditData = []
    data.patternLocationInfo.map((item,index)=>{
      tmpEditData[`locationNum${index}`] = item.locationNum;
      tmpEditData[`shippingCd${index}`] = item.shippingCd;
      tmpEditData[`shippingName${index}`] = item.shippingName;
      item.editLocationNum  = item.locationNum;
    })
    setEditData(tmpEditData)
  },[data])

  const onInsertLocaton = (data) => {
    setDaialogData(data)
    setIsDialogOpen(true)
  }

  //ロケーション番号の指定（1～300）
  function locationMaxValue(elem, maxValue) {
    if(!elem || !elem.target || !elem.target.value) return
    try{
      if(elem.target.value > maxValue || elem.target.value < 1){
        elem.target.value = ''
      }
    }catch(e){
      console.log(e)
      console.log(elem.target.value)
    }
  }  

  if (!data || !data?.patternLocationInfo) return null;
  //console.log(data);
  return (
    <MediaWrap>
      <MediaItem>
        <TextWrap style={{width:'85px', textAlign:'right'}}>
          <div style={{marginRight:'2rem'}}>{data.sort}</div>
        </TextWrap>
      </MediaItem>
      {data?.patternLocationInfo.map((item,index)=>(
      <MediaRow key={data.sort+'_'+index}>
      {isEdit &&
      <>
      <MediaItem>
        <TextWrap style={{width:'100px', textAlign:'center'}}>
          <InputField
            type="number"
            id={`locationNum${index}`}
            value={editData[`locationNum${index}`]}
            onChange={(e)=>handleInputChange(e,index)}
            tabIndex={10+dataIndex+index*dataLength}
            onInput={(e)=>locationMaxValue(e,dataLength)}
          />
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:'100px', textAlign:'center'}}>
          <div style={{marginLeft:'0rem'}}>{editData[`shippingCd${index}`]}</div>
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:'220px', textAlign:'left'}}>
          <div style={{marginLeft:'1rem'}}>{editData[`shippingName${index}`]}</div>
        </TextWrap>
      </MediaItem>
      </>
      }
      {!isEdit &&
      <>
      <MediaItem onClick={()=>onInsertLocaton(item)} style={{cursor:'pointer'}}>
        <TextWrap style={{width:'100px', textAlign:'right'}}>
          <div style={{marginRight:'2rem'}}>{item.locationNum}</div>
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:'100px', textAlign:'center'}}>
          <div style={{marginLeft:'0rem'}}>{item.shippingCd}</div>
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:'220px', textAlign:'left'}}>
          <div style={{marginLeft:'1rem'}}>{item.shippingName}</div>
        </TextWrap>
      </MediaItem>
      </>
      }
      </MediaRow>
      ))}
      {isDialogOpen && <SearchLocationDialog onClose={()=>setIsDialogOpen(false)} data={dialogData} onReSerach={onReSerach}/>}
    </MediaWrap>
  )
}

MediaDataLocation.propTypes = {
  data: PropTypes.object, // ダイアログ
}

export default MediaDataLocation
